{
    "name": "abono-teatro-front",
    "version": "1.0.13",
    "private": true,
    "type": "module",
    "homepage": "https://ab-gitlab.cloudari.com/abono-teatro/abono-teatro-backoffice-ui",
    "engines": {
        "node": ">=22.22.2"
    },
    "scripts": {
        "dev": "vite",
        "build": "tsc && vite build",
        "start": "vite preview",
        "test": "vitest run --bail=1",
        "test:all": "vitest run",
        "test:report": "vitest run --reporter=json > vitest-report.json",
        "coverage": "vitest run --coverage",
        "coverage:open": "node coverage.open.js",
        "coverage-open": "vitest run --coverage && node coverage.open.js",
        "lint": "eslint",
        "prettier:apply": "prettier --write .",
        "prettier:check": "prettier --check .",
        "prettier:check-diff": "git diff --name-only --diff-filter=ACMR -z HEAD | xargs -0 -r npx prettier --check",
        "precommit": "commitlint -e $GIT_PARAMS",
        "cypress": "cypress open",
        "cypress:run": "cypress run",
        "clean": "rm -Rf ./dist ./coverage",
        "clean:all": "rm -Rf ./dist ./coverage ./node_modules",
        "check:all": "yarn lint && yarn prettier:check-diff && yarn build && yarn test:all",
        "audit:summary": "node yarn-audit.js",
        "postinstall": "husky install",
        "release:apply": "dotenv -e .env cross-env CI=true HUSKY=0 npx semantic-release --no-ci"
    },
    "dependencies": {
        "@emotion/react": "^11.14.0",
        "@emotion/styled": "^11.14.1",
        "@hugerte/hugerte-react": "^2.0.2",
        "@mapbox/mapbox-gl-geocoder": "^5.1.2",
        "@mui/icons-material": "^9.5.0",
        "@mui/material": "^9.5.0",
        "@mui/x-data-grid-pro": "^9.15.0",
        "@mui/x-date-pickers-pro": "^9.15.0",
        "@sentry/react": "^11.8.0",
        "@sentry/vite-plugin": "^11.8.0",
        "@tabler/icons-react": "^3.49.0",
        "@tanstack/react-query": "^5.104.4",
        "@tanstack/react-query-devtools": "^5.104.4",
        "autosuggest-highlight": "^3.3.4",
        "axios": "^1.20.0",
        "crypto-js": "^4.2.0",
        "dayjs": "^1.11.23",
        "dompurify": "^3.4.17",
        "dotenv": "^18.0.8",
        "formik": "^2.4.9",
        "i18next": "^26.5.2",
        "i18next-browser-languagedetector": "^8.2.1",
        "immer": "^11.1.21",
        "isomorphic-dompurify": "^4.6.0",
        "lodash": "^4.18.1",
        "mapbox-gl": "^3.33.0",
        "nuqs": "^2.10.2",
        "overlayscrollbars": "^2.16.0",
        "overlayscrollbars-react": "^0.5.6",
        "react": "^19.3.1",
        "react-big-calendar": "^1.20.0",
        "react-dom": "^19.3.1",
        "react-i18next": "^17.1.0",
        "react-image-crop": "^11.1.2",
        "react-map-gl": "^8.1.3",
        "react-number-format": "^5.4.5",
        "react-router-dom": "^7.18.4",
        "react-toastify": "^11.1.0",
        "sms-length": "^0.2.2",
        "yup": "^1.7.1",
        "zustand": "^5.0.15"
    },
    "devDependencies": {
        "@babel/eslint-parser": "^8.0.7",
        "@commitlint/cli": "^21.2.4",
        "@commitlint/config-conventional": "^21.2.4",
        "@commitlint/types": "^21.2.3",
        "@eslint-react/eslint-plugin": "^5.28.1",
        "@eslint/js": "^10.0.1",
        "@semantic-release/changelog": "^7.0.0",
        "@semantic-release/git": "^11.0.1",
        "@testing-library/dom": "^10.4.2",
        "@testing-library/jest-dom": "^7.0.1",
        "@testing-library/react": "^16.3.3",
        "@testing-library/user-event": "^14.6.8",
        "@trivago/prettier-plugin-sort-imports": "^6.0.2",
        "@types/autosuggest-highlight": "^3.2.4",
        "@types/crypto-js": "^4.2.2",
        "@types/dompurify": "^3.2.0",
        "@types/jest": "^30.0.0",
        "@types/lodash": "^4.17.26",
        "@types/mapbox__mapbox-gl-geocoder": "^5.1.2",
        "@types/react": "^19.3.0",
        "@types/react-big-calendar": "^1.16.3",
        "@types/react-dom": "^19.3.0",
        "@typescript-eslint/eslint-plugin": "^8.71.2",
        "@typescript-eslint/parser": "^8.71.2",
        "@vitejs/plugin-react": "^6.1.2",
        "@vitest/coverage-istanbul": "^5.0.5",
        "@vitest/eslint-plugin": "^1.6.27",
        "cross-env": "^10.1.0",
        "cypress": "^16.2.0",
        "dotenv-cli": "^11.0.0",
        "eslint": "^10.13.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-config-vitest-globals": "^2.0.2",
        "eslint-plugin-cypress": "^7.0.2",
        "eslint-plugin-jest-dom": "^5.10.1",
        "eslint-plugin-prettier": "^5.5.7",
        "eslint-plugin-react-hooks": "^7.1.1",
        "eslint-plugin-testing-library": "^7.16.2",
        "eslint-plugin-vitest-globals": "^1.6.1",
        "globals": "^17.13.0",
        "husky": "^9.1.7",
        "jsdom": "^30.1.3",
        "prettier": "^3.9.10",
        "semantic-release": "^25.0.9",
        "typescript": "^6.0.3",
        "typescript-eslint": "^8.71.2",
        "vite": "^8.3.4",
        "vite-plugin-svgr": "^5.2.0",
        "vitest": "^5.0.5"
    }
}
